import { ComponentProps, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

type LabelProps = {
  children: ReactNode;
  semiBold?: boolean;
  truncate?: boolean;
} & ComponentProps<'p'>;

const Label = ({ semiBold = false, children, className, truncate = false }: LabelProps) => {
  return (
    <p
      className={twMerge(
        semiBold ? 'text-sm font-semibold text-ph-gray-evening' : 'text-sm text-ph-gray-white',
        className,
        truncate && 'max-w-8/12 overflow-hidden truncate',
      )}
    >
      {children}
    </p>
  );
};

export default Label;
